import { Component, createSignal, JSX, onMount, Show } from "solid-js"
import { ArtworkLocation } from "./Types";
import { CMS } from "./cms";
import { Map, MarkerDto } from "./Map";
import { render } from "solid-js/web";
import { fetchGet } from "./API";
import { NearbyMuseumsInfoWindow } from "./NearbyMuseumsInfoWindow";

type Props = {
    data: ArtworkLocation;
    onBackToArtworksClicked: () => void;
}

export const NearbyMuseumsTab : Component<Props> = (props) => {
    const [hasMapData, setHasMapData] = createSignal<boolean>(false);
    const [radius, setRadius] = createSignal<string>("5");
    const [data, setData] = createSignal<{ markers: any[]; heatmap: any[] }|null>(null);
    const [mapWidth, setMapWidth] = createSignal<string>("100%");
    const [mapHeight, setMapHeight] = createSignal<string>("600px");
    const [mapIconColour, setMapIconColour] = createSignal<string>("");
    const [mapMode, setMapMode] = createSignal<string>("markers");
    const [heatmapLinkColour, setHeatmapLinkColour] = createSignal<string>("");
    const [markerLinkColour, setMarkerLinkColour] = createSignal<string>("");
    const setMarkerMode = (e: Event) => {
        setMapMode("markers");
        setMarkerLinkColour("red");
        setHeatmapLinkColour("white");
    };
    const setHeatmapMode = (e: Event) => {
        setMapMode("heatmap");
        setMarkerLinkColour("white");
        setHeatmapLinkColour("red");
    };
    const getMapData = async ()  => {
        const response = await fetchGet("/ArtCollection/SolidMapOfArtworkLocationsJson", { id: props.data.Id, radius: radius() });
        const json = await response.json();
        return json;
    };
    const renderToNode = (jsx: JSX.Element) => {
        const node = document.createElement("DIV");
        render(() => jsx, node);
        return node;
    };
    const onMarkerClicked = async (marker: google.maps.Marker, map: google.maps.Map) => {
        const jsx = NearbyMuseumsInfoWindow({ data: marker.data as MarkerDto });
        const content = renderToNode(jsx);
        const infowindow = new google.maps.InfoWindow({ content });
        infowindow.open(map, marker);
    };
    const updateRadiusClicked = async (e: Event) => {
        e.preventDefault();
        await loadMapData();
    }
    const loadMapData = async() => {
        const json = await getMapData();
        const markers = json.Data.Markers.map((x: any) => ({...x, Id: x.Id } as MarkerDto));
        const heatmap = json.Data.Heatmap;
        setHasMapData(false);
        setData({ markers, heatmap });
        setHasMapData(true);
    }
    onMount(async () => {
        await loadMapData();
    })
    return (
        <>
            <div style="color: #efefef; background-color: #333; text-align: left; padding: 20px;">
                <div style="margin: 15px 0; padding: 1px 20px;">
                    <h3 style="font-family: 'Impact'; letter-spacing: 0.15rem; padding-bottom: 10px;">
                        Other museums nearby ...
                    </h3>
                    <div>
                        <input
                            type="number"
                            class="form-control"
                            min={1} max={100}
                            value={radius()}
                            onInput={(e) => setRadius(e.currentTarget.value)}
                            style="width: 100px; margin-right: 10px; float: left;"
                        />
                        miles radius
                        <button class="btn btn-default" type="button" style="margin-left: 10px;" onClick={updateRadiusClicked}>Search</button>
                    </div>
                    <div style="margin-top: 20px;">
                        <div onClick={setMarkerMode} style="display: inline-block; margin-right: 20px;">
                            <div style="position: relative; left: 15px;">
                                <span class="glyphicon glyphicon-map-marker" style={{ "font-size": "2em", "color": mapIconColour() }}></span>
                            </div>
                            <div style={{ "font-family": "Oswald", "font-size": "1em", "letter-spacing": "0.1em", "color": markerLinkColour() }}>
                                <CMS id="label::map">markers</CMS>
                            </div>
                        </div>
                        <div onClick={setHeatmapMode} style="display: inline-block;">
                        <div style="position: relative; left: 15px; top: -5px;">
                                <img src="/images/icons/heatmap.png" style="height: 30px; width: 30px;" />
                            </div>
                            <div style={{ "font-family": "Oswald", "font-size": "1em", "letter-spacing": "0.1em", "color": heatmapLinkColour() }}>
                                <CMS id="label::map">heatmap</CMS>
                            </div>
                        </div>
                    </div>
                </div>
                <p style="color: #efefef; border-top: 2px dotted #efefef; padding: 10px 20px; margin: 0; font-size: 1.5em;" onClick={props.onBackToArtworksClicked}>
                    <span class="fa fa-arrow-circle-left" style="margin-right: 10px;"></span> <CMS id="button::back-to-the-artworks">back to the artworks</CMS>
                </p>
                <Show when={hasMapData()}>
                    <Map
                        width={mapWidth} height={mapHeight}
                        data={data}
                        onMarkerClicked={onMarkerClicked}
                        mode={mapMode}
                    />
                </Show>
            </div>
        </>
    )
}